define('pages/englishlive2016/blockerEvents',[
    'kernel/Defer',
    'kernel/blocker/document',
    'shared/lib/Emitter'
], 
function(
    Defer,
    documentBlocker, 
    Emitter
){
    'use strict';
    var onresuming = documentBlocker.onresuming;
    var defer = new Defer();
    var emitterInstance = new Emitter();

    if (documentBlocker.status === 2) {
        documentBlocker.onresuming = function() {
            return onresuming.apply(this, arguments)
                .then(function(result){
                    // wait until the fading is gone
                    setTimeout(function(){
                        defer.resolve();
                    }, 500);
                    return result;
                });
        };
    }
    else {
        defer.resolve();
    }

    defer.promise.then(function(){
        emitterInstance.reemit('resumed');
    });

    return emitterInstance;
});
